import { DesignTokenSizeEnum } from '../theme-provider';
export { DesignTokenSizeEnum as ContainerGutter };
export var ContainerWrap;

(function (ContainerWrap) {
  ContainerWrap["never"] = "never";
  ContainerWrap["always"] = "always";
  ContainerWrap["auto"] = "auto";
})(ContainerWrap || (ContainerWrap = {}));

export { DesignTokenSizeEnum as ContainerPadding };
export var ContainerHorizontalAlignment;

(function (ContainerHorizontalAlignment) {
  ContainerHorizontalAlignment["flexStart"] = "flex-start";
  ContainerHorizontalAlignment["center"] = "center";
  ContainerHorizontalAlignment["flexEnd"] = "flex-end";
  ContainerHorizontalAlignment["spaceBetween"] = "space-between";
})(ContainerHorizontalAlignment || (ContainerHorizontalAlignment = {}));

export var ContainerVerticalAlignment;

(function (ContainerVerticalAlignment) {
  ContainerVerticalAlignment["flexStart"] = "flex-start";
  ContainerVerticalAlignment["center"] = "center";
  ContainerVerticalAlignment["flexEnd"] = "flex-end";
})(ContainerVerticalAlignment || (ContainerVerticalAlignment = {}));